<template></template>
<script>
export default {
    created() {
        if (this.$store.state.token && this.$store.state.token != '') {
            this.init();
        } else {
            this.$eventBus.$on('wikiPageInit', () => {
                //路由直接访问时被indexInfo触发加载
                this.init();
            });
        }
        //this.init();
    },
    methods: {
        init() {
            let params = this.getCustomParams()
            if (params) {
                this.$router.replace({ name: 'gameInfoMainPage', params: { id: params.id ? params.id : null, type: params.type } });
            } else {
                this.$router.replace({ name: 'gameInfoMainPage' })
            }
        },
        getCustomParams() {
            if (this.$route.query && this.$route.query.wikiType) {
                let typeMap = ['hero', 'mecha', 'weapon', 'pack']
                let typeIndex = typeMap.findIndex(item => item == this.$route.query.wikiType)
                if (typeIndex != -1) {
                    return {
                        type: typeIndex + 1,
                        id: this.$route.query.wikiId ? this.$route.query.wikiId : null
                    }
                }
                return false
            } else {
                return false
            }
        },
    }
}
</script>